<div class="modal-header">
    <h4 class="modal-title d-flex align-items-center" id="modal-basic-title">
      <i class="fas fa-list me-2"></i> {{titulo}}
    </h4>

    <button type="button" class="close" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
     
    <div class="row">
        <div class="col-12">
          <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns" (event)="eventEmitted($event)"></ngx-table>
        </div>

    </div>



  </div>
  <div class="modal-footer">
    <button (click)="cerrar()" type="button" class="btn btn-success">Cerrar</button>
  </div> 

  <!-- Templates para columna de selección -->
  <ng-template #frmSelect let-row>
    <button class="btn btn-primary btn-sm" (click)="seleccionar(row)">
      <i class="fas fa-check"></i>
    </button>
  </ng-template>

  <!-- Template para fecha DocDate con formato dd/MM/yyyy -->
  <ng-template #frmFecha let-row>
    {{ row.DocDate | date: 'dd/MM/yyyy' }}
  </ng-template>